<template>
  <v-ons-page>
    <v-ons-toolbar>
      <div class="center">EllaFashion Login</div>
    </v-ons-toolbar>
    <br>
    <form style="padding: 0.5rem">
      <v-ons-card>
        <div class="content">
          <div>
            <label>Username</label>
            <v-ons-input 
              modifier="underbar" 
              autocomplete="username"
              v-model="username"/>
          </div>
          <div class="field">
            <label>Password</label>
            <v-ons-input type="password" 
              modifier="underbar" 
              autocomplete="current-password"
              @keyup.enter="login"
              v-model="password"/>
          </div>
          <div class="field" style="text-align: right">
            <v-ons-button @click="login">Login</v-ons-button>
          </div>
        </div>
      </v-ons-card>
      <div class="branding">
        <img src="../assets/mariella.png">
      </div>
    </form>
  </v-ons-page>
</template>

<script>
import util from "../util";
export default {
  name: "login-page",
  data() {
    return { username: "", password: "" };
  },
  methods: {
    async login() {
      try {
        const credentials = { username: this.username, password: this.password };
        await this.$api.login(credentials);
        localStorage.setObject("credentials", credentials);
        this.$store.authenticated = true;
      } catch (ex) {
        util.warn(this, "Authentication failed", ex);
      }
    }
  }
}
</script>

<style scoped>
ons-input {
  width: 100%;
}
ons-card {
  margin: auto;
  max-width: 30rem;
}
.field {
  margin-top: 1rem;
}
.branding {
  margin-top: 1.5rem;
  text-align: center;
}
.branding img {
  width: 50%;
  max-width: 250px;
}
</style>



// WEBPACK FOOTER //
// src/pages/LoginPage.vue